import { useCallback, useState } from 'react';
import { profileService } from '../services/profileService';
import { normalizeProfile } from '../utils/normalizeProfile';

export default function useProfileList() {
  const [profiles, setProfiles] = useState([]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProfiles = useCallback(async (filters = {}) => {
    setIsLoading(true);
    setError(null);

    try {
      const res = await profileService.getProfiles(filters);
      if (res.ok) {
        setProfiles(res.data.list || []);
        setCount(res.data.count || 0);
      } else {
        setProfiles([]);
        setCount(0);
        setError('Failed to load profiles');
      }
    } catch (err) {
      setProfiles([]);
      setCount(0);
      setError(err?.message || 'Failed to load profiles');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const prependProfile = useCallback((profile) => {
    const normalized = normalizeProfile(profile);
    if (!normalized) return;
    setProfiles((prev) => [normalized, ...prev]);
    setCount((prev) => prev + 1);
  }, []);

  const updateProfileInList = useCallback((profile) => {
    const normalized = normalizeProfile(profile);
    if (!normalized?.id) return;
    setProfiles((prev) =>
      prev.map((item) => (item.id === normalized.id ? { ...item, ...normalized } : item))
    );
  }, []);

  const removeProfileFromList = useCallback((profileId) => {
    setProfiles((prev) => prev.filter((item) => item.id !== profileId));
    setCount((prev) => Math.max(0, prev - 1));
  }, []);

  return {
    profiles,
    count,
    isLoading,
    error,
    fetchProfiles,
    prependProfile,
    updateProfileInList,
    removeProfileFromList,
  };
}
